var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"active":_vm.isActiveLocal,"scroll":"keep"},on:{"update:active":function($event){_vm.isActiveLocal=$event}}},[_c('video',{attrs:{"controls":"","src":(_vm.publicPath + "kyc-forms-screencast.mp4")}})])}
var staticRenderFns = []

export { render, staticRenderFns }